import api from '@/services/api';

/**
 * Lädt aktive Schüler.
 * Backend-Payload (StudentController::listAll): { items: [...] }
 */
export async function fetchActiveStudents() {
    const res = await api.get('/students/all');
    const data = res?.data;
    return Array.isArray(data?.items) ? data.items : [];
}
